/* eslint-disable */

/**
 * Component Callout
 *
 * Shows a Callout at a specified absolute location.
 */

var Component = require('./component');

var template = '<div class="${classes}">\
                    <h4>${title}</h4>\
                    <p>${description}</p>\
                    <button type="button">${close}</button>\
                </div>';
var templateNoTitle = '<div class="${classes}">\
                    <p>${description}</p>\
                    <button type="button">${close}</button>\
                </div>';

/** @constructor */
/** @param {string} title */
/** @param {string} description */
/** @param {string} close */
function Callout(title, description, close, options) {
  options = Object.assign({
    align: 'justify'
  }, options);

  var classes = ['callout'];
  if(options.align === 'left') {
    classes.push('callout--align-left');
  } else if(options.align === 'right') {
    classes.push('callout--align-right');
  }

  this.__element = Component.create(!!title ? template : templateNoTitle, {
    title: title,
    description: description,
    close: close,
    classes: classes.join(' ')
  });
  this.maxWidth = 320;
  this.minWidth = 120;
}
Callout.prototype = {
  /** @param {HTMLElement} target The HTML element to callout*/
  /** @returns {void} */
  show: function (target, alignment) {
    if(!target){
      return;
    }

    this.__target = target;
    this.__alignment = alignment;
    this._destroyBoundWithThis = this.destroy.bind(this); // we need to store this because we need this 'context'
    this._updatePositionBoundWithThis = this.updatePosition.bind(this); // we need to store this because we need this 'context'


    //since this is a global element next to the body we need to track the position of the target
    window.addEventListener('scroll', this._updatePositionBoundWithThis);
    window.addEventListener('resize', this._updatePositionBoundWithThis);

    document.body.appendChild(this.__element); //todo CSS fade in animation
    this.__element.setAttribute("data-alignment", alignment);


    document.addEventListener("mouseup", this._destroyBoundWithThis);

    this.updatePosition();
  },

  /** @returns {void} */
  destroy: function (e) {
    setTimeout(function () {
      this.__element.parentElement.removeChild(this.__element);

      window.removeEventListener('scroll', this._updatePositionBoundWithThis);
      window.removeEventListener('resize', this._updatePositionBoundWithThis);
      document.removeEventListener('mouseup', this._destroyBoundWithThis);
    }.bind(this), 50)

  },

  /**
   * Repositions the callout
   * closes callout for fixed dixs in IE
   */
  updatePosition: function () {
    var newCalloutTop, newCalloutLeft;

    //get measurements from the target and assing to callout, reducing if size if necessary
    var targetBoundingClientRect = this.__target.getBoundingClientRect();
    var targetHeight = targetBoundingClientRect.height ? targetBoundingClientRect.height : (targetBoundingClientRect.bottom - targetBoundingClientRect.top );
    var targetWidth = targetBoundingClientRect.width ? targetBoundingClientRect.width : (targetBoundingClientRect.right - targetBoundingClientRect.left );

    var elementBoundingClientRect = this.__element.getBoundingClientRect();
    var elementWidth = elementBoundingClientRect.width ? elementBoundingClientRect.width : (elementBoundingClientRect.right - elementBoundingClientRect.left );
    elementWidth = Math.min(Math.max(targetWidth, this.minWidth), this.maxWidth); //clamp it to the boundaries
    this.__element.style.width =elementWidth + "px";

    elementBoundingClientRect = this.__element.getBoundingClientRect();
    var elementHeight = elementBoundingClientRect.height ? elementBoundingClientRect.height : (elementBoundingClientRect.bottom - elementBoundingClientRect.top );

    //IE comp
    var scrollX = window.pageXOffset ? window.pageXOffset : window.document.documentElement.scrollLeft;
    var scrollY = window.pageYOffset ? window.pageYOffset : window.document.documentElement.scrollTop;

    //use the measure menets
    switch (this.__alignment) {
      case Callout.ALIGNMENT_TOP:
        newCalloutTop = targetBoundingClientRect.top - Callout.ALIGNMENT_OFFSET  - elementHeight + scrollY;
        newCalloutLeft = targetBoundingClientRect.left + scrollX;
        break;
      case Callout.ALIGNMENT_BOTTOM:
        newCalloutTop = targetBoundingClientRect.top + targetHeight + Callout.ALIGNMENT_OFFSET + scrollY;
        newCalloutLeft = targetBoundingClientRect.left + scrollX;
        break;
      case Callout.ALIGNMENT_LEFT:
        //we want to align the center of the callout with the center of the target
        newCalloutTop = targetBoundingClientRect.top - elementHeight / 2 + targetHeight / 2 + scrollY;
        newCalloutLeft = targetBoundingClientRect.left - elementWidth - Callout.ALIGNMENT_OFFSET + scrollX;
        break;
      case Callout.ALIGNMENT_RIGHT:
        newCalloutTop = targetBoundingClientRect.top - elementHeight / 2 + targetHeight / 2 + scrollY;
        newCalloutLeft = targetBoundingClientRect.left + targetWidth + Callout.ALIGNMENT_OFFSET + scrollX;
        break;
    }

    //assign positions to the callout
    if (isElementFixedOrChildOfFixedElement(this.__target)) {
      this.__element.style.position = "fixed";
      this.__element.style.left = newCalloutLeft - scrollX + "px";
      this.__element.style.top = newCalloutTop - scrollY + "px";
    } else {
      this.__element.style.position = "absolute";
      this.__element.style.left = newCalloutLeft + "px";
      this.__element.style.top = newCalloutTop + "px";
    }
  }

}

Callout.ALIGNMENT_TOP = "top";
Callout.ALIGNMENT_RIGHT = "right";
Callout.ALIGNMENT_BOTTOM = "bottom";
Callout.ALIGNMENT_LEFT = "left";
Callout.ALIGNMENT_OFFSET = 15;    // Additional pixels to offset position based on the :before value of the element

module.exports = Callout;

//todo extract this to util
/**
 * Is it part of position:fixed
 * Recursive function navigating up the dom tree until root
 * @param element
 * @returns {boolean}
 */
function isElementFixedOrChildOfFixedElement(element) {
  if (window.getComputedStyle(element).position === 'fixed') {
    return true;
  }

  while (element.parentElement) {
    if (window.getComputedStyle(element).position === 'fixed') {
      return true;
    }
    element = element.parentElement;
  }
}
